import React from "react";
import {css, Theme} from "@emotion/react";

import {Image} from "@pg-design/image-module";

interface IProps {
    imageUrl: string;
    className?: string;
}

export const ReelImgCover = (props: IProps) => {
    return <Image alt="" src={props.imageUrl} width="100%" height="100%" css={imgStyle} className={props.className} />;
};

const imgStyle = (theme: Theme) => css`
    background: linear-gradient(90deg, ${theme.colors.gray[400]}, ${theme.colors.gray[500]});
    width: 100%;
    height: 100%;

    img {
        object-fit: cover;
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {Image} from "@pg-design/image-module";

interface IProps {
    imageUrl: string;
    className?: string;
}

export const ReelImgCover = (props: IProps) => {
    return <Image alt="" src={props.imageUrl} width="100%" height="100%" css={imgStyle} className={props.className} />;
};

const imgStyle = (theme: Theme) => css`
    background: linear-gradient(90deg, ${theme.colors.gray[400]}, ${theme.colors.gray[500]});
    width: 100%;
    height: 100%;

    img {
        object-fit: cover;
    }
`;
